<template>
  <div
    class="mui-toggle-btn-group"
    :class="[
      orientation ? `mui-toggle-btn-group--${orientation}` : '',
      {
        'mui-toggle-btn-group--full-width': fullWidth
      }
    ]"
    role="group"
    :aria-label="ariaLabel"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'toggle-button-group',
  props: {
    // Exclusive (single) or multiple selection
    exclusive: {
      type: Boolean,
      default: true
    },
    // Orientation: 'horizontal' or 'vertical'
    orientation: {
      type: String,
      default: 'horizontal',
      validator: (value) => ['horizontal', 'vertical'].includes(value)
    },
    // Full width group
    fullWidth: {
      type: Boolean,
      default: false
    },
    // ARIA label for accessibility
    ariaLabel: {
      type: String,
      default: 'Toggle button group'
    },
    // v-model value for selected button(s)
    value: {
      type: [String, Number, Array],
      default: null
    },
    // Color to apply to selected buttons
    color: {
      type: String,
      default: 'primary'
    },
    // Size for all child buttons
    size: {
      type: String,
      default: 'medium'
    }
  },
  provide() {
    return {
      toggleGroup: this
    };
  },
  mounted() {
    this.propagateProps();
  },
  updated() {
    this.propagateProps();
  },
  methods: {
    propagateProps() {
      // Pass group props to child buttons
      if (this.$children) {
        this.$children.forEach(child => {
          if (child.$options.name === 'MuiToggleButton') {
            // Set size and color from group
            if (this.size && !child.size) {
              child.size = this.size;
            }
            if (this.color && !child.color) {
              child.color = this.color;
            }
          }
        });
      }
    },
    handleToggle(buttonValue) {

      console.log(buttonValue)

      if (!buttonValue) return;
      
      let newValue;
      
      if (this.exclusive) {
        // Exclusive selection - single value
        newValue = this.value === buttonValue ? null : buttonValue;
      } else {
        // Multiple selection - array of values
        const currentValues = Array.isArray(this.value) ? [...this.value] : [];
        const index = currentValues.indexOf(buttonValue);
        
        if (index === -1) {
          currentValues.push(buttonValue);
        } else {
          currentValues.splice(index, 1);
        }
        
        newValue = currentValues;
      }
      
      this.$emit('input', newValue);
      this.$emit('change', newValue);
    },
    isSelected(buttonValue) {
      if (buttonValue === null) return false;
      
      if (this.exclusive) {
        return this.value === buttonValue;
      } else {
        return Array.isArray(this.value) && this.value.includes(buttonValue);
      }
    }
  }
};
</script>

<style scoped>
.mui-toggle-btn-group {
  display: inline-flex;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.16);
}

/* Horizontal Orientation */
.mui-toggle-btn-group--horizontal {
  flex-direction: row;
}

.mui-toggle-btn-group--horizontal .mui-toggle-btn {
  border-radius: 0;
  border-left: none;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.mui-toggle-btn-group--horizontal .mui-toggle-btn:first-child {
  border-left: 1px solid rgba(0, 0, 0, 0.12);
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.mui-toggle-btn-group--horizontal .mui-toggle-btn:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

/* Vertical Orientation */
.mui-toggle-btn-group--vertical {
  flex-direction: column;
}

.mui-toggle-btn-group--vertical .mui-toggle-btn {
  border-radius: 0;
  border-top: none;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.mui-toggle-btn-group--vertical .mui-toggle-btn:first-child {
  border-top: 1px solid rgba(0, 0, 0, 0.12);
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

.mui-toggle-btn-group--vertical .mui-toggle-btn:last-child {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

/* Full Width */
.mui-toggle-btn-group--full-width {
  width: 100%;
}

.mui-toggle-btn-group--full-width .mui-toggle-btn {
  flex: 1;
}
</style>


// WEBPACK FOOTER //
// ToggleButtonGroup.vue?4179e1c0